<nb-card class="modal-full" [nbSpinner]="loading" nbSpinnerSize="medium" nbSpinnerStatus="success" >
  <nb-card-header>
    Update roles from template
  </nb-card-header>
  <nb-card-body>
    <table *ngIf="!loading && gamesChanges.length>0">
      <tr>
        <th class="image">Img Game</th>
        <th>&nbsp;</th>
        <th class="image">Img Template</th>

        <th> | </th>

        <th class="labels">Label Game</th>
        <th>&nbsp;</th>
        <th class="labels">Label Template</th>

        <th> | </th>

        <th class="description">Description Game</th>
        <th>&nbsp;</th>
        <th class="description">Description Template</th>
        
        <th class="object-action">Action</th>
      </tr>
      <ng-template ngFor let-game="$implicit" [ngForOf]="gamesChanges" let-i="index">
        <tr class="object">
          <td colspan="3" class="title-object" (click)="toggleShowDetailGame(i)">
            {{game.name | txtTranslate }}
          </td>
          <td colspan="7"> </td>
          <td colspan="2" class="arrow-button" (click)="toggleShowDetailGame(i)">
            <nb-icon *ngIf="!gameVisibly[i]" icon="arrow-ios-downward-outline"></nb-icon>
            <nb-icon *ngIf="gameVisibly[i]" icon="arrow-ios-upward-outline"></nb-icon>
          </td>
        </tr>
        <tbody [@slideInOut] *ngIf="!gameVisibly[i]">
          <ng-template ngFor let-change="$implicit" [ngForOf]="game?.changes" let-j="index">
            <tr *ngIf="!change.roleGame">
              <td class="image">
                <img [src]="change.template?.fileURL ? change.template?.fileURL : 'https://place-hold.it/50x50&text='" style="width:70px;height:auto;">
              </td>
              <td colspan="4">
                Role '{{change.template?.labels[currentLang]}}' doesn't exist
              </td>
              <td colspan="4" class="text-left">
                <button class="save-btn ml-3" nbButton status="success" (click)="applyChanges(game, change.template, change.roleGame, i, j, 0)">Create in game</button>
              </td>
            </tr>
            <tr *ngIf="change.roleGame">
              <!-- image game -->
              <td class="image">
                <img [src]="change.roleGame?.fileURL ? change.roleGame?.fileURL : 'https://place-hold.it/50x50&text='" style="width:70px;height:auto;">
              </td>
              <td>=></td>
              <!-- image template -->
              <td class="image">
                <img [src]="change.template?.fileURL ? change.template?.fileURL : 'https://place-hold.it/50x50&text='" style="width:70px;height:auto;">
              </td>
    
              <td>|</td>
              <!-- label game -->
              <td class="labels" *ngIf="change.roleGame?.labels[currentLang]">
                <div class="text" [innerHTML]='getDiffAttributes(change.template?.labels[currentLang], change.roleGame?.labels[currentLang],"to")'></div>
              </td>
              <td class="labels" *ngIf="!change.roleGame?.labels[currentLang]">
                <div class="text" style="color:grey;"> Empty Label </div>
              </td>
              <td>=></td>
              <!-- label template -->
              <td class="labels" *ngIf="change.template?.labels[currentLang]">
                <div class="text" [innerHTML]='getDiffAttributes(change.roleGame?.labels[currentLang], change.template?.labels[currentLang],"from")'> </div>
              </td>
              <td class="labels" *ngIf="!change.template?.labels[currentLang]">
                <div class="text" style="color:grey;"> Empty Label </div>
              </td>
    
              <td>|</td>
              <!-- description game -->
              <td class="description" *ngIf="change.roleGame?.description[currentLang]">
                <div class="text" [innerHTML]='getDiffAttributes(change.template?.description[currentLang], change.roleGame?.description[currentLang],"to")'></div>
              </td>
              <td class="description" *ngIf="!change.roleGame?.description[currentLang]">
                <div class="text" style="color:grey;"> Empty Description </div>
              </td>
              <td>=></td>
              <!-- description template -->
              <td class="description" *ngIf="change.template?.description[currentLang]">
                <div [innerHTML]='getDiffAttributes(change.roleGame?.description[currentLang], change.template?.description[currentLang],"from")'></div>
              </td>
              <td class="description" *ngIf="!change.template?.description[currentLang]">
                <div class="text" style="color:grey;"> Empty Description </div>
              </td>
    
    
              <td class="object-action" *ngIf="change.template.id">
                <button *ngIf="change.roleGame?.description[currentLang] || change.roleGame?.pictureUrl || change.roleGame?.labels[currentLang]" class="save-btn" nbButton status="info" (click)="applyChanges(game, change.template, change.roleGame, i, j, 0)">Apply changes in game</button>
              </td>
              <td class="object-action" *ngIf="!change.template.id">
                <div class="text-action">        
                  <button nbButton status="danger" class="save-btn" (click)="deleteRole(change.roleGame, i, j)">Delete role in game</button>
                </div>
              </td>
            </tr>
          </ng-template>
        </tbody>
      </ng-template>
    </table>
    <div class="text-center" *ngIf="!loading && gamesChanges.length==0"> No changes found</div>
  </nb-card-body>
  <nb-card-footer>
    <div class="row">
      <button class="cancel" nbButton status="danger" (click)="close()">Cancel</button>
      <button class="success" nbButton status="success" (click)="applyAllChanges()" *ngIf="!loading && gamesChanges.length>0">Apply all changes</button>
    </div>
  </nb-card-footer>
</nb-card>
